const secondaryPhoneNumberLength = (value) => {
  if (!value) {
    return true;
  }

  const unformatted = value.toString().replace('(', '').replace(')', '').split('-')
    .join('')
    .split(' ')
    .join('');

  return unformatted.length === 11 || unformatted.length === 10;
};

export default secondaryPhoneNumberLength;
